import React, { useState, useEffect } from "react";
import {
  Typography,
  Checkbox,
  FormControl,
  FormGroup,
  FormControlLabel,
  Box,
} from "@mui/material";

function CheckBox({ filter, resetFilters, updateCheckedBoxes }) {
  const [checkBoxes, setCheckboxes] = useState([false]);

  useEffect(() => {
    if (!filter?.values) return;

    const mapped = filter.values.map((v) => ({
      ...v,
      checked: false,
    }));

    setCheckboxes(mapped);
  }, [filter.values, resetFilters]);

  function handleChange(event) {
    const { name, checked } = event.target;

    const updatedCheckBoxes = checkBoxes.map((checkbox) =>
      checkbox.name === name ? { ...checkbox, checked: checked } : checkbox
    );
    setCheckboxes(updatedCheckBoxes);
    updateCheckedBoxes(filter.name, updatedCheckBoxes);
  }

  return (
    <div>
      <FormControl component="fieldset" variant="standard">
        <FormGroup>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 2,
            }}
          >
            {checkBoxes.map((checkbox, index) => (
              <FormControlLabel
                key={checkbox.name || index}
                control={
                  <Checkbox
                    checked={checkbox.checked}
                    onChange={(e) => handleChange(e)}
                    name={checkbox.name}
                  />
                }
                label={<Typography variant="body2">{checkbox.name}</Typography>}
              />
            ))}
          </Box>
        </FormGroup>
      </FormControl>
    </div>
  );
}

export default CheckBox;
